import { useState } from 'react';
import { useSongsBrewState } from '../../../music24/artistHome/songsBrew/useSongsBrewState';

export interface SongsBrewTickBox {
  /** The box shows only when the platform is set up and the status is `none` or `unsubscribed`. */
  isShown: boolean;
  isTicked: boolean;
  setTicked: (ticked: boolean) => void;
  /** True only when the box shows and is ticked: the value for `finishWelcome`. */
  subscribeSongsBrew: boolean;
}

/**
 * The SongsBrew tick box of the welcome (design: songsbrew-promotion b1-b5, b9). It is never ticked
 * at the start. While `newsletter.getState` loads, fails, or answers `available: false`,
 * `subscribed` or `refused`, the box does not show and the welcome sends no SongsBrew field. A
 * refused address gets the same answer again, so a box would promise an email that never comes.
 */
export function useSongsBrewTickBox(): SongsBrewTickBox {
  const { state } = useSongsBrewState();
  const [isTicked, setTicked] = useState(false);
  const isShown = state !== null && (state.status === 'none' || state.status === 'unsubscribed');
  return { isShown, isTicked, setTicked, subscribeSongsBrew: isShown && isTicked };
}
